"use client";

import React, { useState } from "react";
import { VirtualTableView, ospThemes } from "@ospweb/sdk-ui";

import { ColumnsType } from "antd/es/table";
import log from "logbeacon";
import { useStyles } from "../../styles";

interface BaseTableProps {
  columns: ColumnsType<any>;
  dataSource: any[];
  loading: boolean;
  className?: string;
  onRow?: (record: any) => void;
  isSearchLoading?: boolean;
}

export const BaseTable: React.FC<BaseTableProps> = ({
  columns,
  dataSource,
  loading,
  isSearchLoading,
  className,
  onRow,
}) => {
  const { styles, cx } = useStyles();
  const [activeRow, setActiveRow] = useState<any>(null);
  // 计算表格列的总最小宽度
  const totalMinWidth = columns.reduce((total, column) => {
    return total + ((column.width as number) || 100);
  }, 0);

  return (
    <div className="w-full overflow-hidden">
      <VirtualTableView
        columns={columns.map((item:any) =>{
          return{
            ...item,
            title: typeof item.title === "string" ? (
              <span className="body_medium_s">{item.title}</span>
            ) : (
              item.title
            ),
          }
        })}
        dataSource={dataSource}
        rowHeight={52}
        borderConfig={{
          borderWidth: 0,
          borderRadiusSize: 0,
        }}
        cellStyle={
          {
            backgroundColor: ospThemes.colors.background_solid_tertiary,
          } as React.CSSProperties
        }
        onRow={(record: any, index?: number) => ({
          onClick: () => {
            if (index) {
              log.debug(index, "index", isSearchLoading);
              setActiveRow(index);
            }
            onRow?.(record);
          },
          className:
            activeRow === index && isSearchLoading
              ? "opacity-50 cursor-progress"
              : "cursor-pointer",
        })}
        loading={loading}
        pagination={false}
        className={cx(styles.tableCustom, className)}
        scroll={{
          x: totalMinWidth,
        }}
      />
    </div>
  );
};
